<template>
  <v-card
    variant="flat"
    color="rgb(var(--v-theme-component))"
    class="flex_chip"
    :class="isSelected ? 'selected_category' : 'not_selected_category'"
    @click="selectedType">
    <v-card-title>
      <p class="right_panel_title d-flex flex-row align-center">
        <v-avatar size="x-small" class="mr-1">
          <v-icon color="rgb(var(--v-theme-lighten))">{{ item.icon }}</v-icon>
        </v-avatar>
        {{ $t(item.initials_key ?? '') }}
      </p>
      <span class="right_panel_title">
        {{ $t(item.name) }}
      </span>
    </v-card-title>
    <v-card-subtitle>
      {{ currentLabel && t(currentLabel) }}
    </v-card-subtitle>
    <v-card-item :id="'card_item_' + item.initials + '_' + buffer">
      <v-slider
        v-model="slider"
        readonly
        hide-details
        thumb-size="10"
        track-size="6"
        track-fill-color="transparent"
        thumb-color="white"
        max="100"
        min="0"
        class="slider_class"></v-slider>
    </v-card-item>
  </v-card>
</template>

<script setup lang="ts">
import type { CategoryData } from '@/types/Incident'

import { computed, onMounted, ref, watch } from 'vue'

import { storeToRefs } from 'pinia'

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps<{
  item: CategoryData
  buffer: string
}>()

// Weather store
import WeatherStore from '@/stores/weatherStore'
const weatherStore = WeatherStore()
const { category } = storeToRefs(weatherStore)

const slider = ref((25 * (props.item.variableData.values[0] - 1)) as number)

const currentLabel = computed(() => props.item.variableData.colors.find((x) => x.value === props.item.variableData.values[0])?.label)
const emit = defineEmits(['changeType'])

function selectedType() {
  emit('changeType', props.item)
}

const isSelected = ref(false as boolean)

watch(
  () => category.value,
  (value) => {
    isSelected.value = value?.id === props.item.id
  },
  {
    immediate: true
  }
)

function getLinearGradientStyle() {
  const colors = props.item.variableData.colors.map((x) => x.color).reverse()
  let style = `linear-gradient(0.25turn,`
  for (let i = 0; i < colors.length; i++) {
    style += `` + colors[i]
    if (i !== colors.length - 1) {
      style += `, `
    }
  }
  style += `)`
  return style
}

onMounted(() => {
  document
    .getElementById('card_item_' + props.item.initials + '_' + props.buffer)
    ?.style.setProperty('--category-chip-gradient', getLinearGradientStyle())
})
</script>

<style scoped lang="scss">
.v-card-title {
  font-size: 12px !important;
  margin-top: 5px;
  padding: 2px 10px 0px 10px !important;
}
.v-card-subtitle {
  font-size: 18px !important;
  padding: 2px 10px 0 10px !important;
}
.v-card-item {
  margin: 0 !important;
  padding: 0 !important;
}
.flex_chip {
  flex-basis: 100%;
  text-align: left;
  width: 310px !important;
}
.v-card-item ::v-deep(.v-slider-thumb__surface) {
  color: white !important;
  border: 3px solid rgb(var(--v-theme-dark-color));
}
.v-card-item ::v-deep(.v-slider-thumb__ripple) {
  color: red !important;
  user-focus: true;
}
.v-card-item ::v-deep(.v-slider-track__background) {
  background: var(--category-chip-gradient) !important;
}
.selected_category {
  border: 2px rgb(var(--v-theme-primary)) solid;
}
.not_selected_category {
  border: 0;
}

:deep(.v-slider-track) {
  border: 1px rgb(var(--v-theme-grey-color)) solid !important;
}
</style>
